import { useApiQuery } from '../useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { proposalTemplateEndpoints } from '@/lib/api/endpoints';
import { proposalTemplateKeys } from '@/lib/queryKeys';
import type { ProposalTemplateListResponse } from '@/types/proposalTemplate';

export interface UseProposalTemplatesParams {
  search?: string;
  limit?: number;
  page?: number;
  /**
   * Narrow to templates offered to this Business Unit. Omitted means NO
   * predicate — every template, exactly as before business units existed.
   * The server's filter is wildcard-aware: a template with no business units
   * belongs to all of them.
   */
  businessUnitId?: string;
}

export interface UseProposalTemplatesOptions {
  enabled?: boolean;
}

export function useProposalTemplates(
  params: UseProposalTemplatesParams = {},
  options?: UseProposalTemplatesOptions,
) {
  return useApiQuery<ProposalTemplateListResponse>({
    queryKey: proposalTemplateKeys.list(params),
    enabled: options?.enabled,
    queryFn: () =>
      apiGet<ProposalTemplateListResponse>(operationsClient, proposalTemplateEndpoints.list(), {
        params: {
          ...(params.search ? { search: params.search } : {}),
          // Omitted entirely when unset — an empty string would be a filter.
          ...(params.businessUnitId ? { businessUnitId: params.businessUnitId } : {}),
          limit: params.limit ?? 50,
          page: params.page ?? 1,
        },
      }),
    showErrorToast: false,
  });
}
